import _ from 'lodash';

import { InvitationPayload } from '../../types/members.types';

import { TeamMemberPermissions } from './team.constants';
import {
  TeamMember,
  TeamMemberSecurityGroup,
  TeamMemberStatus,
} from './team.types';

const TEAM_MEMBER_PERMISSION_SEPARATOR = '@';

export const normalizeSecurityGroups = (
  securityGroups: string[],
): TeamMemberSecurityGroup[] => {
  return _.reduce<string[], TeamMemberSecurityGroup[]>(
    securityGroups,
    (
      acc: TeamMemberSecurityGroup[],
      group: string,
    ): TeamMemberSecurityGroup[] => {
      const isTeamMemberPermission = Object.values(
        TeamMemberPermissions as { [s: string]: string },
      ).includes(group);

      if (isTeamMemberPermission) {
        acc.push({
          permission: group as TeamMemberPermissions,
        });
      }

      if (_.includes(group, TEAM_MEMBER_PERMISSION_SEPARATOR)) {
        const [permission, projectId] = _.split(
          group,
          TEAM_MEMBER_PERMISSION_SEPARATOR,
        );

        if (
          permission === TeamMemberPermissions.Admin ||
          permission === TeamMemberPermissions.Viewer
        ) {
          acc.push({
            permission,
            projectId,
          });
        }
      }

      return acc;
    },
    [],
  );
};

export const normalizeInvitation = (member: InvitationPayload): TeamMember => {
  return {
    avatarUrl: '',
    id: member.email,
    name: '',
    primaryEmail: {
      address: member.email,
      id: member.email,
      primary: true,
      public: false,
      verified: false,
    },
    securityGroups: normalizeSecurityGroups(member.securityGroups),
    status: TeamMemberStatus.Pending,
  };
};
